import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { GlobalResponse, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AddInternalUserComponent } from '../add-internal-user/add-internal-user.component';
import { CommonService } from '@app/shared-module/common-service.service';
import { ChangepasswordComponent } from '../changepassword/changepassword.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  internalUserList: any[] = [];
  length = 0;
  addInternalUser: MatDialogRef<AddInternalUserComponent>;
  changePassDialog: MatDialogRef<ChangepasswordComponent>;
  user: User;
  isEditEnabled = false;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private service: AdminService,
    public dialog: MatDialog,
    public commonService: CommonService,
  ) { }

  ngOnInit() {
    this.fetchDoctorList();
    this.user = this.commonService.internalLoginValue;
    if (this.user && this.user.role && (this.user.role === Constants.ROLE_ADMIN || this.user.role === Constants.ROLE_OPERATIONS)) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  fetchDoctorList() {
    this.blockUI.start();
    this.service.getInternalUserList(this.pageSize, this.pageNumber).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.length = res.result.internalUserCount;
        this.internalUserList = res.result.internalUser;
      }
    });
  }

  pageEvent(event) {
    // console.log(this.pageSize);
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchDoctorList();
  }

  addNewItem() {
    this.addInternalUser = this.dialog.open(AddInternalUserComponent, {
      disableClose: false
    });
    this.addInternalUser.componentInstance.headerTitle = 'Add User';
    this.addInternalUser.componentInstance.createFlag = true;
    this.addInternalUser.afterClosed().subscribe(result => {
      if (result) {
        this.fetchDoctorList();
      }
      this.addInternalUser = null;
    });
  }

  editLead(item) {
    let userData: any;
    this.blockUI.start();
    this.service.fetchInternalUserDetails(item._id).subscribe(
      (data: GlobalResponse) => {
        this.blockUI.stop();
        if (data && data.message && data.message === Constants.STATUS_SUCCESS) {
          userData = data.result;
          this.addInternalUser = this.dialog.open(AddInternalUserComponent, {
            disableClose: false
          });
          this.addInternalUser.componentInstance.headerTitle = 'Edit User';
          this.addInternalUser.componentInstance.userData = userData;
          this.addInternalUser.componentInstance.createFlag = false;
          this.addInternalUser.componentInstance.updateNameFlag = true;
          this.addInternalUser.afterClosed().subscribe(result => {
            if (result) {
              this.fetchDoctorList();
            }
            this.addInternalUser = null;
          });
        }
      });
  }

  editRole(item: User) {
    this.addInternalUser = this.dialog.open(AddInternalUserComponent, {
      disableClose: false
    });
    this.addInternalUser.componentInstance.headerTitle = 'Update Role';
    this.addInternalUser.componentInstance.userID = item._id;
    this.addInternalUser.componentInstance.role = item.role;
    this.addInternalUser.componentInstance.createFlag = false;
    this.addInternalUser.componentInstance.updateNameFlag = false;
    this.addInternalUser.componentInstance.updateRoleFlag = true;
    this.addInternalUser.afterClosed().subscribe(result => {
      if (result) {
        this.fetchDoctorList();
      }
      this.addInternalUser = null;
    });
  }

  changePassword(item: User) {
    this.changePassDialog = this.dialog.open(ChangepasswordComponent, {
      disableClose: false
    });
    this.changePassDialog.componentInstance.userID = item._id;
    this.changePassDialog.afterClosed().subscribe(result => {
      if (result) {
        this.fetchDoctorList();
      }
      this.addInternalUser = null;
    });
  }

  updateStatus(item, status: string) {
    this.blockUI.start();
    this.service.updateInternalUserStatus(item._id, status).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.fetchDoctorList();
      }
    });
    // } else {
    //   this.toastr.error('Please enter name');
    // }
  }
}
